import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import React, { ComponentProps } from 'react'
import _PriceRowLoyaltyPointsContent from './_PriceRowLoyaltyPointsContent'

interface Props extends ComponentProps<typeof _PriceRowLoyaltyPointsContent> {
  size: 'S' | 'M'
  /**
   * @default start
   */
  horizontalAlign?: 'start' | 'center'
}

const SIZES_BODY_TEXT_VARIANTS: Record<Props['size'], ComponentProps<typeof BodyTextBlock>['variant']> = {
  S: 'small',
  M: 'medium',
}

function PriceRowLoyaltyPoints({
  size,
  horizontalAlign = 'start',
  chainInfo,
  bedbankLoyaltyDisplay,
}: Props) {
  return <BodyTextBlock
    variant={SIZES_BODY_TEXT_VARIANTS[size]}
    colour="lux-plus"
    weight="bold"
    align={horizontalAlign}
  >
    <_PriceRowLoyaltyPointsContent
      bedbankLoyaltyDisplay={bedbankLoyaltyDisplay}
      chainInfo={chainInfo}
    />
  </BodyTextBlock>
}

export default PriceRowLoyaltyPoints
